<template>
  <div>
    <PageTitle title="Edit User" :backBtn="true" :showLoading="isLoading" />
    <v-container fluid class="lighten-12 content">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="8">
          <v-row>
            <v-col>
              <v-card class="lighten-12 card-content mb-1">
                <v-card-title>General</v-card-title>
                <v-container fluid class="light gray lighten-12">
                  <ValidationObserver
                    ref="observer"
                    v-slot="{ validate, reset }"
                  >
                    <form>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Email"
                            vid="email"
                            rules="required|email"
                          >
                            <v-text-field
                              hide-details="auto"
                              outlined
                              dense
                              v-model="user.email"
                              :error-messages="errors"
                              label="E-mail"
                              required
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Username"
                            vid="username"
                            rules="required"
                          >
                            <v-text-field
                              hide-details="auto"
                              outlined
                              dense
                              disabled
                              v-model="user.username"
                              :error-messages="errors"
                              label="UserName"
                              required
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Roles"
                            vid="roles"
                            rules="required"
                          >
                            <v-select
                              hide-details="auto"
                              dense
                              v-model="user.roles"
                              item-text="name"
                              item-value="id"
                              :items="roles"
                              :error-messages="errors"
                              label="Roles"
                              outlined
                            ></v-select>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="KOT Access Type"
                            rules="required"
                          >
                            <v-select
                              hide-details="auto"
                              dense
                              multiple
                              chips
                              small-chips
                              deletable-chips
                              v-model="user.kot_access_types"
                              :items="userTypeOptions"
                              item-text="label"
                              item-value="value"
                              :error-messages="errors"
                              label="KOT Access Type"
                              outlined
                            ></v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Phone"
                            vid="phone"
                            :rules="{
                              required: true,
                              regex: /^[A-Za-z0-9+]{1,15}$/,
                            }"
                          >
                            <v-text-field
                              dense
                              outlined
                              hide-details="auto"
                              v-model="user.contact.phone"
                              :error-messages="errors"
                              label="Phone number"
                              maxlength="15"
                              required
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </form>
                  </ValidationObserver>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12">
              <v-card class="lighten-12">
                <v-container class="light gray lighten-12">
                  <v-row>
                    <v-col cols="12 py-0">
                      <v-flex class="pt-0 pa-1">
                        <FileUpload
                          title="Image"
                          @isImageUpdated="onChangeImageUpload"
                          :multiple="false"
                          v-model="selectedImages"
                          :externalFiles="user.image ? [user.image] : []"
                          size="10000"
                          :types="['jpeg', 'png', 'jpg']"
                          :showPreview="true"
                          :camera="true"
                        />
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col> </v-row
        ></v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="6" lg="12" class="content-flex-end">
          <btn-cancel></btn-cancel>
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            :disabled="isDisabledSubmit"
            >Update</v-btn
          >
        </v-col>
      </v-row>
      <!-- <ChangePassword :username="user.username" /> -->
    </v-container>
  </div>
</template>

<script>
import { required, email, max, regex } from 'vee-validate/dist/rules';
import jwt_decode from 'jwt-decode';
import { mapGetters } from 'vuex';
import { User } from '../../../models/User';
import { UserViewModel } from '../../../models/View Models/UserViewModel';
import FileUpload from '@/components/base/FileUpload';
import ChangePassword from '../../../components/shared/ChangePassword';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { Contact } from '../../../models/Contact';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('no_spaces_only', {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: '{_field_} cannot be empty or spaces only',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});
extend('regex', {
  ...regex,
  message: 'The value is not a valid phone number',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    ChangePassword,
  },
  data: () => ({
    name: '',
    email: '',
    userTypeOptions: [
      { label: 'KOT', value: 1 },
      { label: 'Kitchen', value: 2 },
      { label: 'Waiter', value: 3 },
    ],
    imageUpdated: null,
    show: false,
    isAdmin: false,
    value: String,
    select: null,
    roles: [],
    items: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
    checkbox: null,
    user: {
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      roles: [],
      usertype: 1,
      kot_access_types: [1],
      waiter_id: null,
      address: {},
      contact: { telephone: '', phone: '' },
    },
    loginedUser: new User(),
    isLoading: false,
    errors: [],
    selectedImages: '',
    oldUserDetails: new User(),
    messages: [],
    LoginUser: '',
    CurrentUser: '',
  }),
  computed: {
    ...mapGetters('user', ['GetUsers']),
  },

  methods: {
    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.EditUser();
      }
    },
    clear() {
      this.user = new User();
      this.$refs.observer.reset();
    },
    async UploadUserImage(userId) {
      let fromData = new FormData();

      if (this.selectedImages && this.imageUpdated) {
        fromData.append('image', this.selectedImages);
        fromData.append('id', userId);
        return await this.$store
          .dispatch(`user/UploadUserImage`, fromData)
          .then(() => {})
          .catch(() => {
            this.$toast.error('User image uploading failed');
          });
      } else if (this.imageUpdated == false) {
        fromData.append('image', this.selectedImages);
        fromData.append('id', userId);
        return await this.$store
          .dispatch(`user/UploadUserImage`, fromData)
          .then(() => {})
          .catch(() => {
            this.$toast.error('User image uploading failed');
          });
      } else {
        return true;
      }

      formData.append('id', id);
      console.log(this.selectedImages);
    },

    cancel() {
      this.$router.push({ path: '/user' });
    },
    Reset() {
      this.user = this.oldUserDetails;
      this.$refs.observer.reset();
    },

    EditUser() {
      let userId = this.$route.params.id;
      this.isLoading = true;
      this.user.id = userId;

      this.$store
        .dispatch('user/EditUser', this.user)
        .then(async (res) => {
          this.$router.push('/user');

          await this.UploadUserImage(userId)
            .then(() => {
              this.succeeed = true;
              this.isLoading = false;
              this.$emit('refreshData');
              this.$toast.success('User edited successfully');
              this.$router.push('/user');
            })
            .catch(() => {
              this.isLoading = false;
              this.$toast.error('User edit failed');
            });
        })

        .catch((err) => {
          this.isLoading = false;
          let error = {};
          err.data.error.forEach((element) => {
            error[Object.keys(element)[0]] = element[Object.keys(element)[0]];
          });
          this.$refs.observer.setErrors(error);
          this.messages = err.data.title;
          this.$toast.error('Edit failed');
        });
    },

    GetRoles() {
      this.$store
        .dispatch('user/GetRoles')
        .then((res) => {
          this.roles = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },

    getUser() {
      let userId = this.$route.params.id;
      this.$store
        .dispatch('user/GetSingleUser', userId)
        .then((res) => {
          this.succeeed = true;
          this.user = new UserViewModel(res.data);
          if (this.user.image) {
            this.user.image = this.user.image + '?t=' + Date.now();
          }

          console.log(this.user);
          this.oldUserDetails = this.user;
          this.loginedUser = this.parseJwt(localStorage.getItem('token'));
          const index = this.loginedUser.roles.findIndex(
            (role) => role.name === 'Admin',
          );
          this.isAdmin = index != -1;
          if (index == -1 && this.loginedUser.username !== this.user.username) {
            // this.$router.push("/accessDenied");
          }
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/accessDenied");
        });
    },
    parseJwt(token) {
      jwt_decode(token);
      const user = new User().initialise(jwt_decode(token).rese);
      return user;
    },
  },
  created() {
    this.GetRoles();
    this.getUser();
    // this.GetLoginUser();
    this.loginedUser = this.parseJwt(localStorage.getItem('token'));
  },
};
</script>

<style scoped>
/* .btnRightMargin {
  margin-right: 10px;
}

.container {
  color: white !important;
}
.form-blue {
  background: #d8dbe0;
  border-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.messages {
  border: transparent !important;
  margin-right: 40px;
} */
</style>
